import React from "react";
import { STATO_STYLE, STATI_TRASFERTA } from "@/lib/constants";

export function StatusBadge({ stato, testid }) {
  const style = STATO_STYLE[stato] || "bg-slate-100 text-slate-700 border-slate-300";
  const label = STATI_TRASFERTA.find((s) => s.value === stato)?.label || stato;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${style}`}
    >
      {label}
    </span>
  );
}
